import { getSSSEndpoints, getRSSEndpoints, getTSSEndpoints } from './endpoints.js';
import { SAPPHIRE_NODE_PUB_KEYS } from './pubKeys.js';

const getSapphireNodeDetails = (sapphireNetwork, legacyNetwork, keyType) => {
  return {
    currentEpoch: "1",
    torusNodeEndpoints: getSSSEndpoints(sapphireNetwork, legacyNetwork),
    torusNodeSSSEndpoints: getSSSEndpoints(sapphireNetwork, legacyNetwork),
    torusNodeRSSEndpoints: getRSSEndpoints(sapphireNetwork, legacyNetwork),
    torusNodeTSSEndpoints: getTSSEndpoints(sapphireNetwork, legacyNetwork, keyType),
    torusIndexes: [1, 2, 3, 4, 5],
    torusNodePub: SAPPHIRE_NODE_PUB_KEYS[sapphireNetwork]
  };
};

export { getSapphireNodeDetails };
